import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import store from '@/store';
import axios from 'axios';


Vue.use(VueRouter)

const routes = [
  {
    path: '/dashboard',
    component: () => import('@/layouts/default/Index.vue'),
    children: [
      // {
      // path: '/',
      // name: 'login',
      // component: () => import('../views/auth/login.vue')
      // }, // login
      //  {
      //    path: '/register',
      //    name: 'register',
      //    component: () => import('../views/auth/register.vue')
      //  },
      {
        path: '/about',
        name: 'about',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
      },
      {
        path: '/error/401',
        name: '401',
        component: () => import('../views/error/401.vue')
      },
      {
        path: '/error/media_error',
        name: 'media_error',
        component: () => import('../views/error/media_error.vue')
      },
      {
        path: '/error/404',
        name: '404',
        component: () => import('../views/error/404.vue')
      },
      {
        path: '/error/401_session',
        name: '401_session',
        component: () => import('../views/error/401_session.vue')
      },
      // {
      //   path: '/upload/list',
      //   name: 'sucess',
      //   component: () => import('../views/Sucess.vue')
      // }, //업로드 main
      // {
      //   path: '/upload',
      //   name: 'upload',
      //   component: () => import('../views/upload/upload.vue')
      // }, //업로드
      // {
      //   path: '/upload',
      //   name: '3supload',
      //   component: () => import('../views/upload/3supload.vue')
      // }, //3s 업로드
      {
        path: '',
        name: 'dashboard',
        component: () => import('../views/dashboard/dashboard.vue'),
        // beforeEnter: async (to, from, next) => {
        //   await store.dispatch('app/fetchList');
        //   next();
        // },
      },
      {
        path: '/upload/list',
        name: 'upload',
        component: () => import('../views/upload/uploadObject.vue')
      },
      {
        path: '/cdn',
        name: 'cdn',
        component: () => import('../views/cdn/cdn.vue')
      },
      {
        path: '/cdn/created/:domainName/:lastModifiedTime/:distributionArn/:id',
        name: 'cdncreated',
        component: () => import('../views/cdn/cdn-created.vue'),
        props: (route) => ({ domainName: route.params.domainName, lastModifiedTime: route.params.lastModifiedTime, distributionArn: route.params.distributionArn, id: route.params.id })
      },
      {
        path: '/cdn/create',
        name: 'cdncreate',
        component: () => import('../views/cdn/cdn-create.vue')
      },
      {
        path: '/cdn/create_wowzaserver',
        name: 'cdncreate_wowzaserver',
        component: () => import('../views/cdn/cdncreate-wowzaserver.vue')
      },
      {
        path: '/cdn/info/:dtid',
        name: 'cdninfo',
        component: () => import('../views/cdn/cdn-info.vue'),
        props: (route) => ({ dtid: route.params.dtid })
      },
      {
        path: '/cdn/invalidation/:dtid',
        name: 'cdninvalidation',
        component: () => import('../views/cdn/cdn-invalidation.vue'),
        props: (route) => ({ dtid: route.params.dtid })
      },
      {
        path: '/cdn/info/invalidation/details',
        name: 'cdnInvalidationDetails',
        component: () => import('../views/cdn/cdnInvalidationDetails.vue'),
      },

      {
        path: '/cdn-statistics',
        name: 'statistics',
        component: () => import('../views/cdn/statistics.vue')
      },


      {
        path: '/asset',
        name: 'asset',
        component: () => import('../views/asset/asset.vue')
      }, // 에셋관리
      {
        path: '/asset-view',
        name: 'asset-view',
        component: () => import('../views/asset/asset-view.vue')
      }, // 에셋관리-view
      {
        path: '/asset-view/:name',
        name: 'asset-view',
        component: () => import('../views/asset/asset-view.vue'),
        props: (route) => ({ name: route.params.name })
      },
      {
        path: '/asset-modify',
        name: 'asset-modify',
        component: () => import('../views/asset/asset-modify.vue')
      }, // 에셋관리-modify
      {
        path: '/asset-modify/:name',
        name: 'asset-modify',
        component: () => import('../views/asset/asset-modify.vue'),
        props: (route) => ({ name: route.params.name })
      }, // 에셋관리-modify
      {
        path: '/asset-viewmodify',
        name: 'asset-viewmodify',
        component: () => import('../views/asset/asset-viewmodify.vue')
      }, // 에셋관리-viewmodify

      {
        path: '/playlist',
        name: 'playlist',
        component: () => import('../views/playlist/playlist.vue')
      }, // 플레이리스트

      // {
      //   path: '/player',
      //   name: 'player',
      //   component: () => import('../views/player/player.vue')
      // }, // 플레이어

      {
        path: '/frontmg/frontmg-create',
        name: 'frontmg-create',
        component: () => import('../views/frontmg/frontmg-create.vue'),
      }, //create
      {
        path: '/frontmg/frontmg-Modify/:itemId',
        name: 'frontmg-Modify',
        component: () => import('../views/frontmg/frontmg-Modify.vue')
      }, //Modify

      {
        path: '/cert/cert_list',
        name: 'cert_list',
        component: () => import('../views/cert/cert_list.vue')
      }, // 인증서 리스트
      {
        path: '/cert/cert_import',
        name: 'cert_list',
        component: () => import('../views/cert/cert_import.vue')
      }, // 인증서 import
      {
        path: '/cert/cert_tags',
        name: 'cert_tags',
        component: () => import('../views/cert/cert_tags.vue')
      }, // 인증서 tags
      {
        path: '/cert/cert_review',
        name: 'cert_review',
        component: () => import('../views/cert/cert_review.vue')
      }, // 인증서 review
      {
        path: '/cert/cert_list_noti',
        name: 'cert_list_noti',
        component: () => import('../views/cert/cert_list_noti.vue')
      }, // 인증서 list_noti
      // {
      //   path: '/cert/cert_detail/:arnid',
      //   name: 'certDetail',
      //   component: () => import('../views/cert/cert_detail.vue'),
      //   props: (route) => ({ arn: route.params.arnid })
      // },
      {
        path: '/cert/cert_detail/:certificateId',
        name: 'certDetail',
        component: () => import('../views/cert/cert_detail.vue'),
        props: true
      },
      {
        path: '/admin/user',
        name: 'user',
        component: () => import('../views/admin/user.vue')
      },
      {
        path: '/admin/user-details',
        name: 'user-details',
        component: () => import('../views/admin/user-details.vue')
      },
      {
        path: '/admin/user_details/:tuserid',
        name: 'user_details',
        component: () => import('../views/admin/user_details.vue'),
        props: (route) => ({ tuserid: route.params.tuserid }),
        beforeEnter: (to, from, next) => {
          let user = sessionStorage.getItem('user') ? JSON.parse(sessionStorage.getItem('user')) : null;

          if (user && user.email === 'dev@kcinfra.co.kr') {
            next();
          }
          else if (!user || user.user_id.toString() !== to.params.tuserid) {
            next('/dashboard'); 
          } else {
            next(); 
          }
        }
      },
      {
        path: '/admin/user_create',
        name: 'user_create',
        component: () => import('../views/admin/user_create.vue')
      },
      {
        path: '/admin/encodingservers_list',
        name: 'encodingservers_list',
        component: () => import('../views/admin/encodingservers_list.vue')
      }, // Encoding Server
      {
        path: '/admin/encodingservers_create',
        name: 'encodingservers_create',
        component: () => import('../views/admin/encodingservers_create.vue')
      }, // Encoding Server 등록
      {
        path: '/admin/encodingservers_status',
        name: 'encodingservers_status',
        component: () => import('../views/admin/encodingservers_status.vue')
      }, // Encoding Server Status
      {
        path: '/admin/aws_config_status',
        name: 'aws_config_status',
        component: () => import('../views/admin/aws_config_status.vue')
      }, // Encoding Server Status
      {
        path: '/encoding/edit/:param',
        name: 'encoding_edit',
        component: () => import('../views/encoding/encoding_edit.vue')
      }, // encoding edit
      {
        path: '/encoding/edit',
        name: 'encoding_edit_no',
        component: () => import('../views/encoding/encoding_edit.vue')
      }, // encoding edit
      {
        path: '/encoding/list',
        name: 'encoding_list',
        component: () => import('../views/encoding/encoding_list.vue')
      }, // encoding edit
      {
        path: '/wowza/wowzaservers_list',
        name: 'wowzaservers_list',
        component: () => import('../views/wowza/wowzaservers_list.vue')
      }, // Wowza Server
      {
        path: '/wowza/wowzaservers_create',
        name: 'wowzaservers_create',
        component: () => import('../views/wowza/wowzaservers_create.vue')
      }, // Encoding Server 등록
      {
        path: '/wowzastream/wowzalivestream_create',
        name: 'wowzalivestream_create',
        component: () => import('../views/wowzastream/wowzalivestream_create.vue')
      }, // wowzastream 등록
      {
        path: '/wowzastream/wowzalivestream_view',
        name: 'wowzalivestream_view',
        component: () => import('../views/wowzastream/wowzalivestream_view.vue')
      }, // wowzastream view
      {
        path: '/wowzastream/wowzalivestream_recording',
        name: 'wowzalivestream_recording',
        component: () => import('../views/wowzastream/wowzalivestream_recording.vue')
      }, // wowzastream recording
      {
        path: '/arror',
        name: 'arror',
        component: () => import('../views/arror.vue')
      }, //arror

      {
        path: '/uikit',
        name: 'uikit',
        component: () => import('../views/uikit.vue')
      }, //UI KIT (icon/btn/table)

      {
        path: '/logout',
        name: 'logout',
        component: () => import('../views/auth/logout.vue')
      },
      {
        path: '/upload/option',
        name: 'option',
        component: () => import('../views/upload/upload-option.vue')
      },
      {
        path: '/cms-setting',
        name: 'cms-setting',
        component: () => import('../views/admin/cms-setting.vue')
      },
      {
        path: '/statistics',
        name: 'user-statistics',
        component: () => import('../views/dashboard/statistics.vue')
      },
      {
        path: '/vod-statistics',
        name: 'vod-statistics',
        component: () => import('../views/dashboard/VodStatistics.vue')
      },
      {
        path: '/live-statistics',
        name: 'live-statistics',
        component: () => import('../views/dashboard/LiveStatistics.vue')
      },
      {
        path: '/vod-manual',
        name: 'vod-manual',
        component: () => import('../views/manual/vodmanual.vue')
      },
      {
        path: '/live-manual',
        name: 'live-manual',
        component: () => import('../views/manual/livemanual.vue')
      },
      // {
      //   path: '/password/reset',
      //   beforeEnter(to, from, next) {
      //     if (!to.query.token || !to.query.email) {
      //       next('/');
      //     } else {
      //       next('/password/reset/' + to.query.token);
      //     }
      //   }
      // },
      // {
      //   path: '/password/reset/:token',
      //   name: 'passwordreset',
      //   component: () => import('../views/auth/passwordReset.vue'),
      // }
    ]
  },
  {
    path: '/',
    component: () => import(
      /* webpackChunkName: "layouts-page-index" */
      '@/layouts/page/Index'
    ),
    children: [
      {
        path: '/',
        name: 'login',
        component: () => import('../views/auth/login.vue')
      },
      {
        path: '/password/reset',
        beforeEnter(to, from, next) {
          if (!to.query.token || !to.query.email) {
            next('/');
          } else {
            next('/password/reset/' + to.query.token);
          }
        }
      },
      {
        path: '/password/reset/:token',
        name: 'passwordreset',
        component: () => import('../views/auth/passwordReset.vue'),
      },
    ]
  },
  // {
  //   path: '/player',
  //   name: 'player',
  //   component: () => import('../views/player/player.vue')
  // },
  {
    path: '/player',
    name: 'player',
    component: () => import('../views/player/player-style.vue'), 
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

function checkSessionData() {
  const user = JSON.parse(sessionStorage.getItem("user"));
  if (user) {
    store.commit("user/SET_EMAIL", user.email);
    store.commit("user/SET_LOGIN_STATUS", true);
    store.commit("user/SET_LOGIN_TOKEN", user.token);
  }
}





router.beforeEach(async (to, from, next) => {

  checkSessionData();

  let loggedIn = store.getters['user/isLoggedIn'];

  const isResetPasswordRoute = to.path.startsWith('/password/reset/');

  if (isResetPasswordRoute) {
    return next();
  }

  if (to.path === '/player') {
    return next();
  }

  if (!loggedIn && to.path !== '/') {
    return next('/');
  }

  if (to.path.startsWith('/wowzastream/wowzastream_view')) {
    if (!to.params.itemId) {
      if (loggedIn) {
        return next('/dashboard');
      } else {
        return next('/');
      }
    }

    if (loggedIn) {
      let userAllowedItemIds = await store.dispatch('user/fetchUserAllowedItemIds');
      if (!userAllowedItemIds.includes(parseInt(to.params.itemId, 10))) {
        return next('/dashboard');
      }
    } else {
      return next('/');
    }
  }

  if (to.path !== '/' && to.path !== '/dashboard' && !to.matched.length) {
    return next('/');
  }

  return next();

});





export default router
